module.exports = __webpack_public_path__ + "img/hospital.cf7e7610.jpg";